module.exports = __webpack_public_path__ + "static/media/cotyBanner-desktop-1220x150@2x.c5fe2078.jpg";